import { useAsyncFn } from '@clara/hooks'
import { http, httpBase } from '@/lib'
import {
  Merchant,
  MerchantCategory,
  ReimbursementLabel,
  UserBank,
} from '@/types/api'

type MerchantQuery = {
  countryCode: string
  merchantLang?: string
  name?: string
}

export async function getMerchants(query: MerchantQuery) {
  return http
    .get<Merchant[]>('/merchant', { params: query })
    .then((response) => response.data)
}

type CreateMerchant = Pick<Merchant, 'countryCode' | 'name' | 'description'> & {
  categoryKey: null | number
}

export async function createMerchant(merchant: CreateMerchant) {
  return http
    .post<Merchant>('/merchant', merchant)
    .then((response) => response.data)
}

export function useMerchants(query: MerchantQuery) {
  return useAsyncFn(async () => {
    const response = await getMerchants(query)
    return response
  }, [query])
}

type MerchantCategoryQuery = {
  lang: string
}

export async function getMerchantCategories(query: MerchantCategoryQuery) {
  return http
    .get<{
      catalog: MerchantCategory[]
    }>('/merchant/categories', { params: query })
    .then((response) => response.data.catalog ?? [])
}

export function useMerchantCategories(query: MerchantCategoryQuery) {
  return useAsyncFn(async () => {
    const response = await getMerchantCategories(query)
    return response
  }, [query])
}

export async function getUserBank() {
  return http
    .get<UserBank[]>('/user-bank')
    .then((response) => response.data)
    .then((banks) => banks[0])
}

export function useUserBank() {
  return useAsyncFn(async () => {
    const response = await getUserBank()
    return response
  })
}

export async function getLabels() {
  return httpBase
    .get<ReimbursementLabel[]>('/labels/v1')
    .then((response) => response.data ?? [])
}
